


import { Mixins } from "vue-property-decorator";

import BaseSelect from "Web/Components/Select/Base.vue";

export default class SeparateSelect extends Mixins( BaseSelect ) {
}
